import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { cn } from "../lib/cn";

const STORAGE_KEY = "mgfood_notice_auth_issues_v2";

const MaintenanceBanner = ({ className = "" }) => {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });
  const location = useLocation();

  // Показываем один раз на главном экране И на экране входа
  // (пользователи с проблемами авторизации видят пояснение прямо при входе).
  const noticePaths = []; // уведомление о проблемах скрыто — инцидент устранён
  if (dismissed || !noticePaths.includes(location.pathname)) {
    return null;
  }

  const handleDismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* ignore */
    }
    setDismissed(true);
  };

  return (
    <div
      className={cn(
        "relative w-full rounded-2xl border border-amber-200/80 bg-amber-50/95 px-4 py-3 pr-10 text-amber-950 shadow-sm",
        "dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-100",
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Закрыть уведомление"
        className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-lg text-amber-400 transition hover:bg-amber-100 hover:text-amber-700 dark:text-amber-300/70 dark:hover:bg-amber-400/10 dark:hover:text-amber-100"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-4 w-4"
          aria-hidden="true"
        >
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>

      <div className="flex items-start gap-3">
        <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-amber-100 text-amber-700 dark:bg-amber-400/15 dark:text-amber-200">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-4 w-4"
            aria-hidden="true"
          >
            <path d="M12 9v4" />
            <path d="M12 17h.01" />
            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
          </svg>
        </div>

        <div className="min-w-0">
          <p className="text-sm font-black uppercase tracking-[0.18em] text-amber-700 dark:text-amber-200">
            Наблюдаются проблемы со входом
          </p>
          <p className="mt-1 text-sm font-medium leading-6 text-amber-900 dark:text-amber-50">
            Некоторые пользователи не могут войти в личный кабинет: пин-код
            приходит с задержкой или не приходит. Проблема уже решается —
            сегодня она будет устранена. Проверьте папку «Спам» в почте
            и подождите пару минут: письмо могло просто задержаться.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
